import React from 'react';

const Terms = () => {
  const lastUpdated = '25 Ekim 2025';

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-gray-50 py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Kullanım Koşulları
            </h1>
            <p className="text-lg text-gray-600">
              Son Güncelleme: {lastUpdated}
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto prose prose-lg">
            {/* Genel Hükümler */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              1. Genel Hükümler
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Bu Kullanım Koşulları ("Koşullar"), ContractCode ("biz", "bizim"
              veya "şirket") tarafından işletilen contractcode.com.tr web
              sitesi ("Site") ve ilgili hizmetlerin ("Hizmetler") kullanımını
              düzenler. Siteyi ziyaret ederek veya Hizmetleri kullanarak bu
              Koşulları kabul etmiş sayılırsınız. Bu Koşulları kabul etmiyorsanız,
              lütfen Siteyi ve Hizmetleri kullanmayın.
            </p>

            {/* Hizmet Tanımı */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              2. Hizmet Tanımı
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              ContractCode, kullanıcıların profesyonel hukuki belgeleri hızlı ve
              kolay bir şekilde oluşturmasını sağlayan bir online platformdur.
              Platform, hazır şablonlar, akıllı form sistemi ve belge
              oluşturma araçları sunmaktadır. Hizmetlerimiz, hukuki danışmanlık
              veya tavsiye niteliğinde değildir.
            </p>

            {/* Hesap Oluşturma */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              3. Hesap Oluşturma ve Kullanıcı Sorumlulukları
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Hizmetlerimizi kullanmak için bir hesap oluşturmanız gerekebilir.
              Hesap oluştururken:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>Doğru, tam ve güncel bilgiler sağlamalısınız</li>
              <li>18 yaşından büyük olmalısınız</li>
              <li>Hesap bilgilerinizin güvenliğinden siz sorumlusunuz</li>
              <li>Hesabınızda gerçekleşen tüm aktivitelerden siz sorumlusunuz</li>
              <li>Yetkisiz hesap kullanımını derhal bize bildirmelisiniz</li>
              <li>Birden fazla hesap oluşturamazsınız</li>
            </ul>

            {/* Kullanım Kuralları */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              4. Kullanım Kuralları
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Hizmetlerimizi kullanırken aşağıdaki kurallara uymalısınız:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>Yasalara, düzenlemelere ve üçüncü taraf haklarına saygı göstermelisiniz</li>
              <li>Hizmetleri yalnızca yasal amaçlar için kullanmalısınız</li>
              <li>Zararlı, yanıltıcı veya yasa dışı içerik oluşturamazsınız</li>
              <li>Platformu kötüye kullanamaz veya istismar edemezsiniz</li>
              <li>Sistemi hacklemeye veya güvenliği ihlal etmeye çalışamazsınız</li>
              <li>Başkalarının hesaplarına yetkisiz erişim sağlayamazsınız</li>
              <li>Spam, virüs veya zararlı kod göndere emezsiniz</li>
            </ul>

            {/* Fikri Mülkiyet */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              5. Fikri Mülkiyet Hakları
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Şirket İçeriği:</strong> Site ve Hizmetlerdeki tüm içerik,
              tasarım, logo, metin, grafik, yazılım ve diğer malzemeler
              ContractCode'un veya lisans verenlerinin mülkiyetindedir ve telif
              hakkı, ticari marka ve diğer fikri mülkiyet hakları ile korunmaktadır.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              <strong>Kullanıcı İçeriği:</strong> Platformda oluşturduğunuz
              belgeler ve içerikler size aittir. Ancak, Hizmetleri sağlamak için
              bu içerikleri işleme, saklama ve kullanma hakkını bize
              vermiş olursunuz. Bu hak, hesabınızı sildiğinizde sona erer.
            </p>

            {/* Ücretlendirme ve Ödemeler */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              6. Ücretlendirme ve Ödemeler
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Bazı Hizmetler ücretlidir. Ücretli hizmetler için:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>Seçtiğiniz abonelik planının ücretlerini ödemeyi kabul edersiniz</li>
              <li>Ödemeler, belirtilen periyotlarda otomatik olarak yenilenir</li>
              <li>Fiyatlar önceden bildirimle değiştirilebilir</li>
              <li>İade politikamız ayrı olarak belirtilmiştir</li>
              <li>Ödememe durumunda hesabınız askıya alınabilir</li>
              <li>Tüm ücretler KDV dahildir</li>
            </ul>

            {/* İptal ve Fesih */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              7. İptal ve Fesih
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Kullanıcı İptali:</strong> Hesabınızı istediğiniz zaman
              iptal edebilirsiniz. İptal, mevcut fatura döneminin sonunda
              geçerli olur ve ücret iadesi yapılmaz.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              <strong>Şirket Feshi:</strong> Bu Koşulları ihlal etmeniz durumunda,
              hesabınızı askıya alabilir veya feshedebiliriz. Ciddi ihlallerde,
              hesabınız derhal sonlandırılabilir.
            </p>

            {/* Sorumluluk Reddi */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              8. Sorumluluk Reddi ve Garantiler
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Hizmetlerimiz "olduğu gibi" ve "mevcut olduğu şekliyle" sağlanır.
              Aşağıdaki hususları kabul edersiniz:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>Hizmetlerin kesintisiz veya hatasız olacağını garanti etmiyoruz</li>
              <li>Şablonlar genel kullanım içindir, özel durumlarınıza uygun olmayabilir</li>
              <li>Oluşturulan belgelerin hukuki geçerliliğini garanti etmiyoruz</li>
              <li>Hukuki danışmanlık hizmeti sunmuyoruz</li>
              <li>Özel durumlar için bir avukata danışmanızı öneririz</li>
              <li>Platform arızaları veya veri kayıplarından sorumlu değiliz</li>
            </ul>

            {/* Sorumluluk Sınırlaması */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              9. Sorumluluk Sınırlaması
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Yasal olarak izin verilen azami ölçüde, ContractCode ve bağlı
              şirketleri, yöneticileri, çalışanları ve temsilcileri, Hizmetlerin
              kullanımından veya kullanılamamasından kaynaklanan dolaylı, arızi,
              özel veya cezai zararlardan sorumlu tutulamaz. Sorumluluğumuz,
              son 12 ayda ödediğiniz toplam ücretle sınırlıdır.
            </p>

            {/* Tazminat */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              10. Tazminat
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Hizmetleri kullanımınızdan, bu Koşulları ihlal etmenizden veya
              üçüncü taraf haklarını ihlal etmenizden kaynaklanan tüm iddialar,
              talepler, zararlar ve masraflar (avukatlık ücretleri dahil) için
              ContractCode'u tazmin etmeyi ve zararsız tutmayı kabul edersiniz.
            </p>

            {/* Uyuşmazlık Çözümü */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              11. Uyuşmazlık Çözümü ve Yetkili Mahkeme
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Bu Koşullardan doğan uyuşmazlıklar öncelikle dostane görüşmelerle
              çözülmeye çalışılacaktır. Çözülemezse, Ankara Mahkemeleri ve İcra
              Daireleri yetkilidir ve Türk Hukuku uygulanır.
            </p>

            {/* Değişiklikler */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              12. Koşullarda Değişiklikler
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Bu Kullanım Koşullarını zaman zaman güncelleyebiliriz. Önemli
              değişiklikler için size bildirim gönderilebilir. Değişiklikler
              yayınlandıktan sonra Hizmetleri kullanmaya devam etmeniz,
              değişiklikleri kabul ettiğiniz anlamına gelir.
            </p>

            {/* Genel Hükümler */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              13. Diğer Hükümler
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>
                <strong>Bütünlük:</strong> Bu Koşullar, taraflar arasındaki
                tam anlaşmayı oluşturur
              </li>
              <li>
                <strong>Feragat:</strong> Bir hakkın kullanılmaması, o hakkın
                feragat edildiği anlamına gelmez
              </li>
              <li>
                <strong>Bölünebilirlik:</strong> Bir hükmün geçersiz olması,
                diğer hükümleri etkilemez
              </li>
              <li>
                <strong>Devir:</strong> Bu Koşulları bizim onayımız olmadan
                devredemezsiniz
              </li>
            </ul>

            {/* İletişim */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              14. İletişim
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Bu Kullanım Koşulları ile ilgili sorularınız için bizimle
              iletişime geçebilirsiniz:
            </p>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mb-6">
              <p className="text-gray-900 font-semibold mb-2">ContractCode</p>
              <p className="text-gray-700 mb-1">
                E-posta: legal@contractcode.com.tr
              </p>
              <p className="text-gray-700 mb-1">
                Telefon: +90 (312) 123 45 67
              </p>
              <p className="text-gray-700">
                Adres: Örnek Mahallesi, Teknoloji Caddesi No: 123, Çankaya,
                Ankara 06000
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

Terms.propTypes = {};

export default Terms;

